import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const HexagonGridAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const side = 25 * (1-progress);
  for(let i=0; i<12; i++){
    const ang = (i/12) * Math.PI * 2;
    const dst = e.maxRadius + progress * 50;
    const r = getRadiusAtAngle(ang, e, dst);
    const hx = e.pos.x + Math.cos(ang)*r;
    const hy = e.pos.y + Math.sin(ang)*r;
    ctx.beginPath();
    for(let j=0; j<6; j++){
      const ja = (j/6)*Math.PI*2;
      ctx.lineTo(hx + Math.cos(ja)*side, hy+Math.sin(ja)*side);
    }
    ctx.closePath(); ctx.stroke();
  }
};

registerBlastAnimation('HEXAGON_GRID', HexagonGridAnimation);
